const appConfig = {
    apiPrefix: 'https://app.thedgs.co.uk',
    stagingApiPrefix: 'https://api.thedgs-staging.co.uk',
    authenticatedEntryPath: '/app/dashboard',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/app/account/kyc-form',
    locale: 'en',
    enableMock: false,
}

export default appConfig
